"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentLibraryStateService = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _inversify = require("inversify");
var _rxjsUtils = require("./rxjsUtils");
var _dec, _dec2, _dec3, _class;
/* eslint-disable @typescript-eslint/no-unsafe-call */
var initialState = {
  bearerToken: null,
  bulkTaggedAssets: [],
  collectionKey: null,
  reviewOpened: false,
  userPermissions: null
};
var ContentLibraryStateService = exports.ContentLibraryStateService = (_dec = (0, _inversify.injectable)(), _dec2 = Reflect.metadata("design:type", Function), _dec3 = Reflect.metadata("design:paramtypes", []), _dec(_class = _dec2(_class = _dec3(_class = class ContentLibraryStateService {
  // observable built out of all the subjects

  /**
   * All subscribable subsets of data in the state service
   */

  constructor() {
    /**
     * Set the reviewOpened state
     * @param reviewOpened New value for the reviewOpened state
     */
    (0, _defineProperty2.default)(this, "setReviewOpened", reviewOpened => {
      this.subjects.reviewOpened$.next(reviewOpened);
    });
    (0, _defineProperty2.default)(this, "setBearerToken", bearerToken => {
      this.subjects.bearerToken$.next(bearerToken);
    });
    (0, _defineProperty2.default)(this, "setBulkTaggedAssets", assetIds => {
      this.subjects.bulkTaggedAssets$.next(assetIds);
    });
    (0, _defineProperty2.default)(this, "setCollectionKey", collectionKey => {
      this.subjects.collectionKey$.next(collectionKey);
    });
    /**
     * Set the userPermissions state
     * @param userPermissions New va lue for the userPermissions state
     */
    (0, _defineProperty2.default)(this, "setUserPermissions", userPermissions => {
      this.subjects.userPermissions$.next(userPermissions);
    });
    (0, _defineProperty2.default)(this, "setContentLibraryDI", contentLibraryDI => {
      this.contentLibraryDI = contentLibraryDI;
    });
    /**
     * Take a snapshot of the state of the state service
     */
    (0, _defineProperty2.default)(this, "getStateSnapshot", () => {
      return Object.keys(this.subjects).reduce((acc, key) => {
        var nonSubjectKey = key.slice(0, -1);
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, acc), {}, {
          [nonSubjectKey]: this.subjects[key].getValue()
        });
      }, {});
    });
    (0, _defineProperty2.default)(this, "getContentLibraryDI", () => {
      return this.contentLibraryDI;
    });
    (0, _defineProperty2.default)(this, "subscribeBulkTaggedAssets", callback => {
      return this.subjects.bulkTaggedAssets$.subscribe(callback);
    });
    /**
     * Subscribe to the entire state of the state service. Be careful using this as it can trigger unnecessary re-renders.
     * @param callback Function to call when anything in the state changes
     */
    (0, _defineProperty2.default)(this, "subscribeFullState", callback => {
      return this.combinedStateObservable$.subscribe(callback);
    });
    /**
     * Subscribe to the reviewOpened state
     * @param callback Function to call when the reviewOpened state changes
     */
    (0, _defineProperty2.default)(this, "subscribeReviewOpened", callback => {
      return this.subjects.reviewOpened$.subscribe(callback);
    });
    /**
     * Subscribe to the assetKey and bearerToken state
     * @param callback Function to call when the assetKey and bearerToken state changes
     */
    (0, _defineProperty2.default)(this, "subscribeAppInitialization", callback => {
      return this.combinedStateObservable$.subscribe(_ref => {
        var bearerToken = _ref.bearerToken,
          collectionKey = _ref.collectionKey,
          userPermissions = _ref.userPermissions;
        return callback({
          bearerToken,
          collectionKey,
          userPermissions
        });
      });
    });
    /**
     * Subscribe to the userPermissions state
     * @param callback Function to call when the userPermissions state changes
     */
    (0, _defineProperty2.default)(this, "subscribeUserPermissions", callback => {
      return this.subjects.userPermissions$.subscribe(callback);
    });
    this.subjects = (0, _rxjsUtils.subjectify)(initialState);
    // combine all subjects into a single observable
    this.combinedStateObservable$ = (0, _rxjsUtils.combineSubjects)(this.subjects);
  }
}) || _class) || _class) || _class);
//# sourceMappingURL=contentLibraryStateService.js.map